import EventHandler from '@pixelunion/events';

import ProductQuickshop from './ProductQuickshop';
import Video from './Video';

export default class ProductThumbnail {
  constructor(productThumbnail, settings) {
    this.events = new EventHandler();
    this.settings = settings;

    this.productThumbnail = productThumbnail;
    this.productImageContainer = this.productThumbnail.querySelector('[data-media-wrapper]');
    this.productPrimaryMedia = this.productThumbnail.querySelector('[data-primary-media]');
    this.productSecondaryMedia = this.productThumbnail.querySelector('[data-secondary-media]');
    this.productThumbnailVideo = this.productThumbnail.querySelector('[data-thumbnail-video]');
    this.collectionSwatches = this.productThumbnail.querySelectorAll('[data-swatch]');
    this.productImage = this.productThumbnail.querySelector('[data-rimg]');

    this.secondaryImage = null;
    this.secondaryImageSrc = null;
    this.secondaryImageSrcset = null;

    if (!this.productImage) { return; }

    this.events.register(this.productImage, 'rimg:load', () => {
      this.defaultImageSrc = this.productImage.src;
      this.defaultImageSrcset = this.productImage.srcset;
    });

    if (this.viewportIsMobile()) { return; }

    this.quickshop = new ProductQuickshop(this.productThumbnail);

    if (!this.productSecondaryMedia) { return; }

    this.secondaryImage = this.productSecondaryMedia.querySelector('[data-rimg]');

    this.events.register(this.secondaryImage, 'rimg:load', () => {
      this.secondaryImageSrc = this.secondaryImage.src;
      this.secondaryImageSrcset = this.secondaryImage.srcset;
    });

    this.setupSwatches();

    if (this.settings.showSecondaryMediaOnHover) {
      if (this.productThumbnailVideo) {
        const video = this.productThumbnailVideo.querySelector('[data-html5-video] video, [data-external-video]');

        this.videoPlayer = new Video(video, {
          muted: true,
        });
      }

      this.setupSecondaryMediaSwap();
    }
  }

  setupSecondaryMediaSwap() {
    this.events.register(this.productImageContainer, 'mouseover', () => {
      if (this.secondaryImageSrc) {
        this.secondaryImage.src = this.secondaryImageSrc;
        this.secondaryImage.srcset = this.secondaryImageSrcset;
      }

      this.productPrimaryMedia.classList.add('hidden');

      if (this.productThumbnailVideo) {
        this.productThumbnailVideo.classList.remove('hidden');
        this.productSecondaryMedia.classList.add('hidden');
        this.videoPlayer.play();
      } else {
        this.productSecondaryMedia.classList.remove('hidden');
      }
    });

    this.events.register(this.productImageContainer, 'mouseleave', () => {
      this.productPrimaryMedia.classList.remove('hidden');

      if (this.videoPlayer) {
        this.productThumbnailVideo.classList.add('hidden');
        this.videoPlayer.pause();
      } else {
        this.productSecondaryMedia.classList.add('hidden');
      }
    });
  }

  setupSwatches() {
    /* When hovering over a swatch with an image
    associated with it,set the thumbnail image to
    the associated image */
    this.collectionSwatches.forEach(swatch => {
      this.events.register(swatch, 'mouseover', () => {
        if (swatch.dataset.image.indexOf('no-image') === -1) {
          this.secondaryImage.src = swatch.dataset.image;
          this.secondaryImage.srcset = swatch.dataset.image;
          this.productPrimaryMedia.classList.add('hidden');
          this.productSecondaryMedia.classList.remove('hidden');
        } else {
          this.productPrimaryMedia.classList.remove('hidden');
          this.productSecondaryMedia.classList.add('hidden');
        }
      });
    });
  }

  viewportIsMobile() {
    return window.innerWidth < 768;
  }

  unload() {
    this.events.unregisterAll();
  }
}
